
import { DefaultState, Filters, RoomStatuses } from 'store/types';

export const READ_OCCUPANCY_RATE_DATA_REQUEST = 'READ_OCCUPANCY_RATE_DATA_REQUEST';
export const READ_OCCUPANCY_RATE_DATA_SUCCESS = 'READ_OCCUPANCY_RATE_DATA_SUCCESS';
export const READ_OCCUPANCY_RATE_DATA_FAILURE = 'READ_OCCUPANCY_RATE_DATA_FAILURE';

export interface OccupancyRateParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
};

export interface OccupancyRateRow {
  occupancy: number;
  reservationId: string;
  id: string;
  lodgingOptionName: string;
  corporateClientName: string;
  lodgingOptionLocation: string | null;
  lodgingOptionId: string;
  fromDate: string;
  toDate: string;
  bookingUserFriendlyId: number | null;
  percentageBooked: number;
  status: RoomStatuses;
  notesCount: number;
  totalNumberOfNights: number;
  totalReservationAmount: string;
};

export interface OccupancyRateData {
  rows: OccupancyRateRow[];
  totalCount: number;
};

export type ReadOccupancyRateState = DefaultState & {
  contents?: OccupancyRateData;
};

interface ReadOccupancyRateDataRequest {
  type: typeof READ_OCCUPANCY_RATE_DATA_REQUEST;
};

interface ReadOccupancyRateDataSuccess {
  type: typeof READ_OCCUPANCY_RATE_DATA_SUCCESS,
  contents: OccupancyRateData;
}

interface ReadOccupancyRateDataFailure {
  type: typeof READ_OCCUPANCY_RATE_DATA_FAILURE;
}

export type OccupancyRateActionTypes = ReadOccupancyRateDataRequest | ReadOccupancyRateDataSuccess | ReadOccupancyRateDataFailure;